import { ChatClient } from '../../components/chat-system/ChatClient';
import { Box, useTheme } from '@mui/material';
import Div100vh from 'react-div-100vh';
import Cookies from 'universal-cookie';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useChatClient } from '../../components/chat-system/useChatClient';

const ChatApp = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const [searchParams] = useSearchParams();
  const { conversations, setSelectedConversation } = useChatClient();
  const conversationId = searchParams.get('conversation');

  // get background image
  const cookies = new Cookies();
  const storedBackgroundImageDark = cookies.get('backgroundImageDark')
    ? cookies.get('backgroundImageDark')
    : '/assets/uploads/background-dark.webp';
  const storedBackgroundImageLight = cookies.get('backgroundImageLight')
    ? cookies.get('backgroundImageLight')
    : '/assets/uploads/background-bright.webp';

  // Auto-select conversation from URL parameter
  useEffect(() => {
    if (conversationId && conversations.length > 0) {
      const conversation = conversations.find(c => c.id === parseInt(conversationId));
      if (conversation) {
        setSelectedConversation(conversation);
      }
    }
  }, [conversationId, conversations, setSelectedConversation]);

  return (
    <Div100vh>
      <Box
        className="h-full w-full p-3"
        sx={{
          backgroundImage:
            mode === 'dark'
              ? 'url(' + storedBackgroundImageDark + ')'
              : 'url(' + storedBackgroundImageLight + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center bottom',
        }}
      >
        <ChatClient isStandalone />
      </Box>
    </Div100vh>
  );
};

export default ChatApp;
